export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    $('input[type=range]').on('input', calculateValues);

    updateTooltip('#salary', '#salary-tooltip', true);
    updateTooltip('#overtime', '#overtime-tooltip', false);

    // Check if a specific id is in view and fire the CountUp Function
    var counter = 0;
    const numberOfStats = $('#home-company-statistics .stat-item-wrp').length+1;

    $('.one-col-animation').children().addClass('highlight');

    var observer = new IntersectionObserver(function(entries) {
      if(entries[0].isIntersecting === true)
        if (counter == 0) {
          setTimeout(function(){
            counter++;
            for (let i = 1; i < numberOfStats; i++) {
              document.querySelector('#final-'+ i).classList.remove('d-none');
              document.querySelector('#initial-'+ i).classList.add('d-none');
            }
            countUp();
          }, 200);
        }
    }, { threshold: [0.1] });

    observer.observe(document.querySelector('#home-company-statistics'));
  },
};

$(window).on('resize', function () {
  updateTooltip('#salary', '#salary-tooltip', true);
  updateTooltip('#overtime', '#overtime-tooltip', false);
});

$(window).on('load', function () {
  updateTooltip('#salary', '#salary-tooltip', true);
  updateTooltip('#overtime', '#overtime-tooltip', false);

  const resultValues = calculateValues();
  let userURL = $('#url-span').html();

  $('#intro-button').attr('href', userURL + '?h=' + resultValues.weeklyOvertime + '&a=' + resultValues.annualSalary + '&wd=' + resultValues.workingWeeks);
});

let lastScrollTop = 0;

$(window).on('scroll', function() {
  checkElements();

  let scrollTop = $(this).scrollTop();
  let scrollingDown = scrollTop > lastScrollTop;
  lastScrollTop = scrollTop;

  $('.services-wrp').children().each(function() {
    let $el = $(this);
    let elementTop = $el.offset().top;
    let elementHeight = $el.outerHeight();
    let elementCenter = elementTop + (elementHeight / 2);

    let viewportCenter = scrollTop + ($(window).height() / 2);

    if (scrollingDown) {
      if (elementCenter < viewportCenter && !$el.hasClass('passed-center')) {
        $el.addClass('passed-center');
      }
    } else {
      if (elementCenter > viewportCenter && $el.hasClass('passed-center')) {
        $el.removeClass('passed-center');
      }
    }
  });
});

function countUp() {
  $('.count').each(function () {
    $(this)
      .prop('Counter', 0)
      .animate(
        {
          Counter: $(this).text(),
        },
        {
          duration: 2000,
          easing: 'swing',
          step: function (now) {
            now = Number(Math.ceil(now)).toLocaleString('en');
            $(this).text(now);
          },
        }
      );
    }
  );
}

function updateTooltip(slider, tooltip, isSalary = false) {
  let value = parseInt($(slider).val());
  let formattedValue = isSalary ? `£${value / 1000}K` : `${value}h`;

  $(tooltip).text(formattedValue);

  let percent =
    ((value - $(slider).attr('min')) /
      ($(slider).attr('max') - $(slider).attr('min'))) *
    100;

  let sliderWidth = $(slider).width();
  let thumbWidth = 18; // Approximate thumb width
  let offset = (percent / 100) * (sliderWidth - thumbWidth) + thumbWidth / 2;

  $(tooltip).css({
    'left': `${offset}px`,
    'visibility': 'visible',
  });

  // Fill range with color
  $(slider).css(
    'background',
    `linear-gradient(to right, #0d8cff ${percent}%, #e2e2e2 ${percent}%)`
  );
}

function isElementCentered($element) {
  var elementTop = $element.offset().top;
  var elementHeight = $element.outerHeight();
  var elementCenter = elementTop + (elementHeight / 2);

  var scrollTop = $(window).scrollTop();
  var viewportHeight = $(window).height();
  var viewportCenter = scrollTop + (viewportHeight / 2);

  return Math.abs(elementCenter - viewportCenter) < 50;
}

function checkElements() {
  $('.highlight').each(function() {
    if (isElementCentered($(this))) {
      $(this).addClass('centered');
    }
  });
}

function calculateValues() {
  let weeklyOvertime = parseInt($('#overtime').val());
  let annualSalary = parseInt($('#salary').val());
  let userURL = $('#url-span').html();

  let workingWeeks = parseInt($('#number-of-weeks').html());
  if (isNaN(workingWeeks)) {
    workingWeeks = 40;
  }

  let unpaidHours = weeklyOvertime * workingWeeks;
  let unpaidDays =  Math.round(unpaidHours / 6);
  let hourlyRate = annualSalary / (30 * workingWeeks);
  let financialValue = Math.round(unpaidHours * hourlyRate);

  animateValue('#unpaid-hours', parseInt($('#unpaid-hours').text()), unpaidDays);
  animateValue('#financial-value', parseInt($('#financial-value').text()), financialValue);

  $('#desc-hour').text(unpaidDays.toLocaleString());
  $('#desc-salary').text(financialValue.toLocaleString());

  updateTooltip('#salary', '#salary-tooltip', true);
  updateTooltip('#overtime', '#overtime-tooltip', false);

  $('#intro-button').attr('href', userURL + '?h=' + weeklyOvertime + '&a=' + annualSalary + '&wd=' + workingWeeks );

  return {
    annualSalary: annualSalary,
    weeklyOvertime: weeklyOvertime,
    workingWeeks: workingWeeks,
  };
}

function animateValue(id, start, end) {
  let obj = $(id);
  let isFinancial = id === '#financial-value';

  $({ val: start }).animate({ val: end }, {
    duration: 500,
    step: function (val) {
      let displayVal = isFinancial ? Math.round(val).toLocaleString() : Math.round(val);
      obj.text(displayVal);
    },
  });
}
